/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ query: NonNullable<unknown> }} Search_ResultsInputs */

const en_search_results = /** @type {(inputs: Search_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Search results: ${i?.query}`)
};

const nl_search_results = /** @type {(inputs: Search_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zoekresultaten: ${i?.query}`)
};

/**
* | output |
* | --- |
* | "Search results: {query}" |
*
* @param {Search_ResultsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const search_results = /** @type {((inputs: Search_ResultsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_ResultsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_search_results(inputs)
	return en_search_results(inputs)
});